import type { ThreadCreatedEventData } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event";
import type { SupportTicketTimelineEventResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event-response";
import MessageTextSquareIcon from "@redotech/redo-icons/message-text-square-02.svg";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { formatSentenceCase } from "@redotech/util/string";
import { memo } from "react";
import { EventTimestamp } from "./event-timestamp";
import * as styles from "./timeline-event.module.css";

export const ThreadCreatedEvent = memo(function ThreadCreatedEvent({
  event,
  data,
}: {
  event: SupportTicketTimelineEventResponse;
  data: ThreadCreatedEventData;
}) {
  return (
    <Flex align="flex-start" className={styles.card} gap="sm">
      <Flex
        align="center"
        className={`${styles.icon} ${styles.iconBlue}`}
        justify="center"
      >
        <MessageTextSquareIcon />
      </Flex>
      <Flex className={styles.content} dir="column" gap="xxs">
        <Text fontSize="xs" fontWeight="medium" textColor="primary">
          Thread created on {formatSentenceCase(data.channel)}
        </Text>
        {data.externalThreadId && (
          <Text className={styles.details} fontSize="xxs" textColor="secondary">
            {data.externalThreadId}
          </Text>
        )}
        <EventTimestamp event={event} />
      </Flex>
    </Flex>
  );
});
